// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var IOUtils = require("../../../../shared/src/IOUtils.bs.js");
var ReactIO = require("../../../../shared/src/ReactIO.bs.js");
var Reselect = require("../../../../shared/src/bindings/Reselect.bs.js");
var WebStore = require("../../store/WebStore.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var ReactUtils = require("../../../../shared/src/ReactUtils.bs.js");
var Relude_Set = require("relude/src/Relude_Set.bs.js");
var WebEnvVars = require("../../WebEnvVars.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var StringUtils = require("../../../../shared/src/StringUtils.bs.js");
var BrowserStyle = require("../../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var FormalityCompat = require("re-formality/src/FormalityCompat.bs.js");
var Relude_Js_Promise = require("relude/src/js/Relude_Js_Promise.bs.js");
var WebGraphql_Shifts = require("../../graphql/WebGraphql_Shifts.bs.js");
var Relude_AsyncResult = require("relude/src/Relude_AsyncResult.bs.js");
var WebStore_Selectors = require("../../store/WebStore_Selectors.bs.js");
var WebStore_Types_Error = require("../../store/WebStore_Types_Error.bs.js");
var WebStore_Types_Action = require("../../store/WebStore_Types_Action.bs.js");
var BrowserComponents_Icon = require("../../../../shared-browser/src/components/BrowserComponents_Icon.bs.js");
var BrowserComponents_Field = require("../../../../shared-browser/src/components/BrowserComponents_Field.bs.js");
var BrowserComponents_Input = require("../../../../shared-browser/src/components/BrowserComponents_Input.bs.js");
var CommonTypes_PhoneNumber = require("../../../../shared/src/types/CommonTypes_PhoneNumber.bs.js");
var BrowserComponents_Spacer = require("../../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_Loading = require("../../../../shared-browser/src/components/BrowserComponents_Loading.bs.js");
var BrowserComponents_Subtext = require("../../../../shared-browser/src/components/BrowserComponents_Subtext.bs.js");
var WebComponents_SettingsModal = require("../../components/settings/WebComponents_SettingsModal.bs.js");
var BrowserComponents_FlexColumn = require("../../../../shared-browser/src/components/BrowserComponents_FlexColumn.bs.js");
var WebComponents_SettingsHeader = require("../../components/settings/WebComponents_SettingsHeader.bs.js");
var CommonTypes_Business_Location = require("../../../../shared/src/types/business/CommonTypes_Business_Location.bs.js");
var WebComponents_SettingsListRow = require("../../components/settings/WebComponents_SettingsListRow.bs.js");
var BrowserBindings_GoogleMapReact = require("../../../../shared-browser/src/bindings/BrowserBindings_GoogleMapReact.bs.js");
var FormalityCompat__PublicHelpers = require("re-formality/src/FormalityCompat__PublicHelpers.bs.js");
var WebComponents_SettingsTabHeader = require("../../components/settings/WebComponents_SettingsTabHeader.bs.js");
var BrowserComponents_ValidationError = require("../../../../shared-browser/src/components/BrowserComponents_ValidationError.bs.js");
var FormalityCompat__FormAsyncOnChange = require("re-formality/src/FormalityCompat__FormAsyncOnChange.bs.js");
var WebComponents_SettingsFormActionButtons = require("../../components/settings/WebComponents_SettingsFormActionButtons.bs.js");

var token = WebEnvVars.vars.googleMapsWebClientApiToken;

var invisible = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display("none"),
      tl: /* [] */0
    });

var wrapper = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* XLarge */5, undefined)(/* [] */0));

var mapContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.border(BrowserStyle.rem(0.125), "solid", {
            TAG: /* Grey */2,
            _0: /* Medium */2
          }),
      tl: {
        hd: BrowserStyle.borderRadius(BrowserStyle.Input.borderRadius),
        tl: {
          hd: BrowserStyle.height(BrowserStyle.rem(12.5)),
          tl: /* [] */0
        }
      }
    });

var Styles = {
  invisible: invisible,
  wrapper: wrapper,
  mapContainer: mapContainer
};

function coercePhoneNumber(maybePhoneNumber) {
  return Curry._2(Relude_Option.Infix.$less$pipe$great, Curry._2(Relude_Option.Infix.$less$pipe$great, CommonTypes_PhoneNumber.fromString(maybePhoneNumber), CommonTypes_PhoneNumber.fromString("+" + maybePhoneNumber)), CommonTypes_PhoneNumber.fromString("+1" + maybePhoneNumber));
}

function coercePhoneNumber$1(param) {
  return Relude_Globals.$great$great(StringUtils.getNumbersOnly, coercePhoneNumber, param);
}

function initialState(locationInfo, fetchGeocodeForAddress) {
  return Relude_Option.getOrElse({
              address: "",
              fetchGeocodeForAddress: fetchGeocodeForAddress,
              name: ""
            }, Relude_Option.map((function (param) {
                    return {
                            address: param.address,
                            fetchGeocodeForAddress: fetchGeocodeForAddress,
                            name: param.name
                          };
                  }), locationInfo));
}

var debounceInterval = FormalityCompat.Async.debounceInterval;

function get(param) {
  return param.name;
}

function update(setState, state, name) {
  return Curry._2(setState, /* Name */0, {
              address: state.address,
              fetchGeocodeForAddress: state.fetchGeocodeForAddress,
              name: name
            });
}

function validator_validate(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great(get, Relude_String.toNonWhitespace, param);
                            }), (function (param) {
                              return Relude_Option.map((function (param) {
                                            return Relude_Globals.$$const(/* Valid */0, param);
                                          }), param);
                            }), param);
              }), (function (param) {
                return Relude_Result.fromOption("Must have a location name.", param);
              }), param);
}

var validator = {
  field: /* Name */0,
  strategy: /* OnFirstBlur */0,
  dependents: undefined,
  validate: validator_validate,
  validateAsync: undefined
};

var NameField = {
  get: get,
  update: update,
  validator: validator
};

function get$1(param) {
  return param.address;
}

function update$1(setState, state, address) {
  return Curry._2(setState, /* Address */1, {
              address: address,
              fetchGeocodeForAddress: state.fetchGeocodeForAddress,
              name: state.name
            });
}

function getGeocode(state) {
  return Curry._2(Relude_IO.mapError, (function (param) {
                return Relude_Globals.$$const(/* InvalidAddress */1, param);
              }), Curry._1(state.fetchGeocodeForAddress, get$1(state)));
}

var partial_arg = Curry._1(Relude_IO.mapError, (function (param) {
        return Relude_Globals.$$const("Input a valid address", param);
      }));

function getAddressValidationResult(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great(getGeocode, (function (param) {
                              return Relude_IO.map((function (param) {
                                            return Relude_Globals.$$const(/* Valid */0, param);
                                          }), param);
                            }), param);
              }), partial_arg, param);
}

var partial_arg$1 = Relude_Result.ok(/* Valid */0);

function validator_validate$1(param) {
  return Relude_Globals.$$const(partial_arg$1, param);
}

var validator_validateAsync = [
  (function (param) {
      return Relude_Globals.$great$great((function (param) {
                    return Relude_Globals.$great$great((function (param) {
                                  return Relude_Globals.$great$great(getAddressValidationResult, (function (param) {
                                                return Relude_IO.map(Relude_Result.ok, param);
                                              }), param);
                                }), (function (param) {
                                  return Relude_IO.catchError((function (param) {
                                                return Relude_Globals.$great$great(Relude_Result.error, Relude_IO.pure, param);
                                              }), param);
                                }), param);
                  }), Relude_Js_Promise.fromIO, param);
    }),
  (function (prev, next) {
      return Relude_String.eq(get$1(prev), get$1(next));
    })
];

var validator$1 = {
  field: /* Address */1,
  strategy: /* OnFirstChange */1,
  dependents: undefined,
  validate: validator_validate$1,
  validateAsync: validator_validateAsync
};

var AddressField = {
  get: get$1,
  update: update$1,
  getGeocode: getGeocode,
  getAddressValidationResult: getAddressValidationResult,
  validator: validator$1
};

var validators_1 = {
  hd: validator$1,
  tl: /* [] */0
};

var validators = {
  hd: validator,
  tl: validators_1
};

var Form = {
  initialState: initialState,
  debounceInterval: debounceInterval,
  NameField: NameField,
  AddressField: AddressField,
  validators: validators
};

var FormContainer = FormalityCompat__FormAsyncOnChange.Make({
      debounceInterval: debounceInterval,
      validators: validators
    });

function WebContainers_BusinessDashboard_Settings_Locations$AddEditLocation(Props) {
  var fetchGeocodeForAddress = Props.fetchGeocodeForAddress;
  var headerText = Props.headerText;
  var $$location = Props.location;
  var onCancel = Props.onCancel;
  var saveButtonBusyText = Props.saveButtonBusyText;
  var saveButtonText = Props.saveButtonText;
  var saveLocation = Props.saveLocation;
  var match = Curry._2(FormContainer.useForm, initialState($$location, fetchGeocodeForAddress), (function (param, param$1) {
          var notifyOnFailure = param$1.notifyOnFailure;
          var notifyOnSuccess = param$1.notifyOnSuccess;
          var partial_arg = initialState($$location, fetchGeocodeForAddress);
          var partial_arg$1 = function (param) {
            return Relude_Globals.$$const(partial_arg, param);
          };
          var partial_arg$2 = function (param) {
            return Relude_Globals.$great$great(partial_arg$1, Relude_Option.pure, param);
          };
          var partial_arg$3 = function (param) {
            return Relude_Globals.$great$great(partial_arg$2, notifyOnSuccess, param);
          };
          var partial_arg$4 = Curry._1(Relude_IO.mapError, (function (param) {
                  return Relude_Globals.$$const(/* ErrorUpdatingOrAddingLocation */0, param);
                }));
          return Relude_IO.unsafeRunAsync((function (param) {
                        return Relude_Result.fold(notifyOnFailure, partial_arg$3, param);
                      }), Relude_IO.flatMap((function (param) {
                            return Relude_Globals.$great$great(saveLocation, partial_arg$4, param);
                          }), Relude_IO.pure(CommonTypes_Business_Location.New.make(param.name, param.address))));
        }));
  var submit = match.submit;
  var blur = match.blur;
  var change = match.change;
  var submitting = match.submitting;
  var result = match.result;
  var status = match.status;
  var state = match.state;
  var partial_arg = {
    geocode: undefined,
    currentFetchTimeout: undefined
  };
  var match$1 = React.useState(function () {
        var param;
        return Relude_Globals.$$const(partial_arg, param);
      });
  var setFetchGeocodeState = match$1[1];
  var match$2 = match$1[0];
  var currentFetchTimeout = match$2.currentFetchTimeout;
  var geocode = match$2.geocode;
  var updateCurrentFetchTimeout = function (nextFetchTimeout) {
    Relude_Option.fold(undefined, (function (prim) {
            clearTimeout(prim);
            
          }), currentFetchTimeout);
    return Relude_Globals.$great$great(Relude_Globals.$$const, setFetchGeocodeState, {
                geocode: geocode,
                currentFetchTimeout: nextFetchTimeout
              });
  };
  React.useEffect((function () {
          updateCurrentFetchTimeout(Relude_Option.pure(setTimeout((function (param) {
                          return Relude_IO.unsafeRunAsync((function (param) {
                                        return Relude_Result.fold((function (param) {
                                                      return Relude_Globals.$great$great(Relude_Globals.$$const, setFetchGeocodeState, {
                                                                  geocode: undefined,
                                                                  currentFetchTimeout: undefined
                                                                });
                                                    }), (function (param) {
                                                      var param_geocode = Relude_Option.pure(param.geocode);
                                                      var param$1 = {
                                                        geocode: param_geocode,
                                                        currentFetchTimeout: undefined
                                                      };
                                                      return Relude_Globals.$great$great(Relude_Globals.$$const, setFetchGeocodeState, param$1);
                                                    }), param);
                                      }), Curry._2(Relude_IO.mapError, (function (param) {
                                            return Relude_Globals.$$const(undefined, param);
                                          }), getGeocode(state)));
                        }), debounceInterval)));
          return Relude_Option.pure(function (param) {
                      return updateCurrentFetchTimeout(undefined);
                    });
        }), [get$1(state)]);
  var tmp;
  tmp = typeof status === "number" || !(status.TAG === /* SubmissionFailed */1 && !status._0) ? false : true;
  return React.createElement("form", {
              className: wrapper,
              onSubmit: (function (param) {
                  return FormalityCompat__PublicHelpers.Dom.preventDefault(submit, param);
                })
            }, React.createElement(BrowserComponents_FlexColumn.make, {
                  children: null
                }, React.createElement(WebComponents_SettingsHeader.make, {
                      title: headerText
                    }), React.createElement(BrowserComponents_Input.make, Curry._4(BrowserComponents_Input.makeProps(Curry._1(result, /* Name */0))(undefined, undefined, undefined, undefined, Relude_Option.isSome($$location) || submitting, undefined, {
                              TAG: /* Shift */6,
                              _0: /* Direction */11
                            }, undefined, undefined, undefined, undefined, Relude_IO.suspend(function (param) {
                                  return Curry._1(blur, /* Name */0);
                                }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, "Location Name", undefined, undefined, undefined, undefined), {
                          TAG: /* Text */7,
                          _0: {
                            onChange: (function (param) {
                                return Relude_Globals.$great$great(Relude_IO.pure, (function (param) {
                                              return Relude_IO.map((function (param) {
                                                            return update(change, state, param);
                                                          }), param);
                                            }), param);
                              }),
                            value: get(state)
                          }
                        }, undefined, undefined, undefined)), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Medium */4
                    }), React.createElement(BrowserComponents_Field.Title.make, {
                      title: "Address"
                    }), React.createElement(BrowserComponents_Subtext.make, {
                      className: invisible,
                      children: "I am here to juke out google"
                    }), React.createElement(BrowserComponents_Input.Legacy.Address.make, {
                      disabled: submitting,
                      value: get$1(state),
                      icon: {
                        TAG: /* Shift */6,
                        _0: /* Location */13
                      },
                      onChange: (function (param) {
                          return update$1(change, state, param);
                        }),
                      onBlur: (function (param) {
                          return Curry._1(blur, /* Address */1);
                        })
                    }), React.createElement(BrowserComponents_ValidationError.make, {
                      validationResult: Curry._1(result, /* Address */1)
                    }), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Large */5
                    }), React.createElement("div", {
                      className: Curry._1(Css.merge, {
                            hd: mapContainer,
                            tl: {
                              hd: "location-map",
                              tl: /* [] */0
                            }
                          })
                    }, Relude_Option.fold(null, (function (geoPoint) {
                            return React.createElement(BrowserBindings_GoogleMapReact.make, BrowserBindings_GoogleMapReact.makeProps(undefined, Caml_option.some(React.createElement(BrowserBindings_GoogleMapReact.PositionalChild.make, BrowserBindings_GoogleMapReact.PositionalChild.makeProps(geoPoint, React.createElement(BrowserComponents_Icon.make, {
                                                            icon: {
                                                              TAG: /* Small */1,
                                                              _0: {
                                                                TAG: /* Shift */6,
                                                                _0: /* Location */13
                                                              }
                                                            },
                                                            size: /* Small */1
                                                          }), undefined, undefined))), 16, token, geoPoint, undefined, undefined));
                          }), geocode)), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* XLarge */6
                    }), React.createElement(WebComponents_SettingsFormActionButtons.make, {
                      isSubmitting: submitting,
                      onCancel: onCancel,
                      showError: tmp,
                      submitButtonTitle: saveButtonText,
                      submitButtonBusyTitle: saveButtonBusyText
                    })));
}

var AddEditLocation = {
  token: token,
  Styles: Styles,
  coercePhoneNumber: coercePhoneNumber$1,
  Form: Form,
  FormContainer: FormContainer,
  make: WebContainers_BusinessDashboard_Settings_Locations$AddEditLocation
};

function WebContainers_BusinessDashboard_Settings_Locations$EditView(Props) {
  var fetchGeocodeForAddress = Props.fetchGeocodeForAddress;
  var locationId = Props.locationId;
  var onCancel = Props.onCancel;
  var onSave = Props.onSave;
  var savedLocations = Props.savedLocations;
  return React.createElement(WebContainers_BusinessDashboard_Settings_Locations$AddEditLocation, {
              fetchGeocodeForAddress: fetchGeocodeForAddress,
              headerText: Relude_Option.isSome(locationId) ? "Edit Location" : "Add New Location",
              location: Curry._2(Relude_Option.flatMap, (function (locationId) {
                      return Curry._2(Relude_Array.find, (function ($$location) {
                                    return $$location.id === locationId;
                                  }), savedLocations);
                    }), locationId),
              onCancel: onCancel,
              saveButtonBusyText: "Saving Location",
              saveButtonText: "Save Location",
              saveLocation: onSave
            });
}

var EditView = {
  make: WebContainers_BusinessDashboard_Settings_Locations$EditView
};

function WebContainers_BusinessDashboard_Settings_Locations$RemoveLocationModal(Props) {
  var isShowing = Props.isShowing;
  var id = Props.id;
  var name = Props.name;
  var removeBusinessLocation = Props.removeBusinessLocation;
  var setSettingsPageView = Props.setSettingsPageView;
  var match = ReactIO.useState(Relude_AsyncResult.completeOk);
  var loadingStatus = match[0];
  var disabled = Relude_AsyncResult.foldByValue(true, (function (param) {
          return Relude_Globals.$$const(false, param);
        }), (function (param) {
          return Relude_Globals.$$const(false, param);
        }), loadingStatus);
  var removeText = Relude_AsyncResult.foldByValue(true, (function (param) {
          return Relude_Globals.$$const(false, param);
        }), (function (param) {
          return Relude_Globals.$$const(false, param);
        }), loadingStatus) ? "REMOVING..." : "REMOVE LOCATION";
  if (isShowing) {
    return React.createElement(WebComponents_SettingsModal.make, {
                confirmButtonTitle: removeText,
                description: "Removing a location will remove it from your saved locations while posting a shift. You can always add it back later.",
                disabled: disabled,
                onConfirm: IOUtils.ioWithStatus(undefined, match[1], Curry._1(removeBusinessLocation, id)),
                onCancel: Curry._1(setSettingsPageView, /* Viewing */0),
                showError: Relude_Option.isSome(Relude_AsyncResult.getError(loadingStatus)),
                title: "Remove the " + (name + " location?")
              });
  } else {
    return null;
  }
}

var RemoveLocationModal = {
  make: WebContainers_BusinessDashboard_Settings_Locations$RemoveLocationModal
};

function WebContainers_BusinessDashboard_Settings_Locations$LocationsList(Props) {
  var savedLocations = Props.savedLocations;
  var removeButtonText = Props.removeButtonText;
  var removeBusinessLocation = Props.removeBusinessLocation;
  var removingBusinessLocationId = Props.removingBusinessLocationId;
  var setSettingsPageView = Props.setSettingsPageView;
  var layout = Props.layout;
  return Curry._2(Relude_Array.map, (function (param) {
                var name = param.name;
                var id = param.id;
                return React.createElement("div", {
                            key: Curry._1(CommonTypes_Business_Location.Id.toString, id)
                          }, React.createElement(WebComponents_SettingsListRow.make, {
                                layout: layout,
                                onClickEdit: Curry._1(setSettingsPageView, {
                                      TAG: /* Editing */0,
                                      _0: id
                                    }),
                                onClickRemove: Curry._1(setSettingsPageView, {
                                      TAG: /* Removing */1,
                                      _0: id
                                    }),
                                primaryText: name,
                                removeButtonText: removeButtonText,
                                secondaryText: param.address
                              }), React.createElement(WebContainers_BusinessDashboard_Settings_Locations$RemoveLocationModal, {
                                isShowing: removingBusinessLocationId === Caml_option.some(id),
                                id: id,
                                name: name,
                                removeBusinessLocation: removeBusinessLocation,
                                setSettingsPageView: setSettingsPageView
                              }));
              }), savedLocations);
}

var LocationsList = {
  make: WebContainers_BusinessDashboard_Settings_Locations$LocationsList
};

function WebContainers_BusinessDashboard_Settings_Locations$ListView(Props) {
  var savedLocations = Props.savedLocations;
  var removeBusinessLocation = Props.removeBusinessLocation;
  var removingBusinessLocationId = Props.removingBusinessLocationId;
  var setSettingsPageView = Props.setSettingsPageView;
  var layout = Props.layout;
  return React.createElement(React.Fragment, undefined, React.createElement(WebComponents_SettingsTabHeader.make, {
                  addButtonClick: Curry._1(setSettingsPageView, /* Creating */1),
                  addButtonText: "Add Location",
                  title: "Locations"
                }), React.createElement(WebContainers_BusinessDashboard_Settings_Locations$LocationsList, {
                  savedLocations: savedLocations,
                  removeButtonText: "Remove",
                  removeBusinessLocation: removeBusinessLocation,
                  removingBusinessLocationId: removingBusinessLocationId,
                  setSettingsPageView: setSettingsPageView,
                  layout: layout
                }));
}

var ListView = {
  make: WebContainers_BusinessDashboard_Settings_Locations$ListView
};

function WebContainers_BusinessDashboard_Settings_Locations$Presentation(Props) {
  var addBusinessLocation = Props.addBusinessLocation;
  var editBusinessLocation = Props.editBusinessLocation;
  var fetchGeocodeForAddress = Props.fetchGeocodeForAddress;
  var fetchSavedLocations = Props.fetchSavedLocations;
  var layout = Props.layout;
  var removeBusinessLocation = Props.removeBusinessLocation;
  var savedLocations = Props.savedLocations;
  var setSettingsPageView = Props.setSettingsPageView;
  var subPage = Props.subPage;
  ReactIO.useHandledIOOnMount(undefined)(fetchSavedLocations);
  return Relude_AsyncResult.foldByValue(React.createElement(BrowserComponents_Loading.make, {}), (function (savedLocations) {
                var tmp;
                if (typeof subPage === "number") {
                  tmp = subPage === /* Viewing */0 ? React.createElement(WebContainers_BusinessDashboard_Settings_Locations$ListView, {
                          savedLocations: savedLocations,
                          removeBusinessLocation: removeBusinessLocation,
                          removingBusinessLocationId: undefined,
                          setSettingsPageView: setSettingsPageView,
                          layout: layout
                        }) : React.createElement(WebContainers_BusinessDashboard_Settings_Locations$EditView, {
                          fetchGeocodeForAddress: fetchGeocodeForAddress,
                          onCancel: Curry._1(setSettingsPageView, /* Viewing */0),
                          onSave: addBusinessLocation,
                          savedLocations: savedLocations
                        });
                } else if (subPage.TAG === /* Editing */0) {
                  var locationId = subPage._0;
                  tmp = React.createElement(WebContainers_BusinessDashboard_Settings_Locations$EditView, {
                        fetchGeocodeForAddress: fetchGeocodeForAddress,
                        locationId: locationId,
                        onCancel: Curry._1(setSettingsPageView, /* Viewing */0),
                        onSave: (function (param) {
                            return Curry._1(editBusinessLocation, CommonTypes_Business_Location.make(param.address, locationId, param.name));
                          }),
                        savedLocations: savedLocations
                      });
                } else {
                  tmp = React.createElement(WebContainers_BusinessDashboard_Settings_Locations$ListView, {
                        savedLocations: savedLocations,
                        removeBusinessLocation: removeBusinessLocation,
                        removingBusinessLocationId: Caml_option.some(subPage._0),
                        setSettingsPageView: setSettingsPageView,
                        layout: layout
                      });
                }
                return React.createElement(React.Fragment, undefined, tmp);
              }), (function (error) {
                return React.createElement(ReactUtils.S.make, {
                            children: WebStore_Types_Error.dispatchErrorToString(error)
                          });
              }), savedLocations);
}

var Presentation = {
  make: WebContainers_BusinessDashboard_Settings_Locations$Presentation
};

var mapStateToProps = Reselect.createSelector3(undefined, WebStore_Selectors.getAuthorizedClient, (function (param) {
        return param.layout;
      }), (function (param) {
        return param.savedLocations;
      }), (function (authorizedClient, layout, savedLocations) {
        return {
                authorizedClient: authorizedClient,
                layout: layout,
                savedLocations: Relude_AsyncResult.map(Relude_Set.toArray, savedLocations)
              };
      }));

function mapDispatchToProps(dispatch, param) {
  var authorizedClient = param.authorizedClient;
  return {
          addBusinessLocation: (function (newLocation) {
              return Curry._2(Relude_IO.mapError, (function (prim) {
                            
                          }), Curry._1(dispatch, WebStore_Types_Action.addBusinessLocation(newLocation)));
            }),
          editBusinessLocation: (function (updatedLocation) {
              return Curry._2(Relude_IO.mapError, (function (prim) {
                            
                          }), Curry._1(dispatch, WebStore_Types_Action.editBusinessLocation(updatedLocation)));
            }),
          fetchGeocodeForAddress: (function (address) {
              var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
                      
                    }));
              var partial_arg$1 = Curry._1(WebGraphql_Shifts.GeocodeAddress.query, address);
              return Relude_IO.flatMap((function (param) {
                            return Relude_Globals.$great$great(partial_arg$1, partial_arg, param);
                          }), Relude_IO.fromOption((function (prim) {
                                
                              }), authorizedClient));
            }),
          fetchSavedLocations: Curry._2(Relude_IO.mapError, (function (prim) {
                  
                }), Curry._1(dispatch, WebStore_Types_Action.fetchSavedLocationsForCurrentUser)),
          removeBusinessLocation: (function (id) {
              return Curry._2(Relude_IO.mapError, (function (prim) {
                            
                          }), Curry._1(dispatch, WebStore_Types_Action.removeBusinessLocation(id)));
            })
        };
}

function WebContainers_BusinessDashboard_Settings_Locations(Props) {
  var subPage = Props.subPage;
  var setSettingsPageView = Props.setSettingsPageView;
  return React.createElement(WebStore.Provider.make, {
              mapStateToProps: mapStateToProps,
              mapDispatchToProps: mapDispatchToProps,
              children: (function (param, param$1) {
                  return React.createElement(WebContainers_BusinessDashboard_Settings_Locations$Presentation, {
                              addBusinessLocation: param$1.addBusinessLocation,
                              editBusinessLocation: param$1.editBusinessLocation,
                              fetchGeocodeForAddress: param$1.fetchGeocodeForAddress,
                              fetchSavedLocations: param$1.fetchSavedLocations,
                              layout: param.layout,
                              removeBusinessLocation: param$1.removeBusinessLocation,
                              savedLocations: param.savedLocations,
                              setSettingsPageView: setSettingsPageView,
                              subPage: subPage
                            });
                })
            });
}

var make = WebContainers_BusinessDashboard_Settings_Locations;

exports.AddEditLocation = AddEditLocation;
exports.EditView = EditView;
exports.RemoveLocationModal = RemoveLocationModal;
exports.LocationsList = LocationsList;
exports.ListView = ListView;
exports.Presentation = Presentation;
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = mapDispatchToProps;
exports.make = make;
/* invisible Not a pure module */
